import React, { createContext, useContext, useState, useCallback } from "react";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [interest, setInterest] = useState("Clarity Session");

  const openBooking = useCallback((preset = "Clarity Session") => {
    setInterest(preset);
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ open, setOpen, interest, setInterest, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
}
